export default __webpack_public_path__ + "assets/images/ada88fe2d2f0b3f151eb8a8ff37eac66.svg";